import Swal from 'sweetalert2'

const submitHandler = (note, score, putRequest, setLoading, setIsEdit, assignmentData) => {
  const { assignmentUser, getAllUsers, handleCloseModal } = assignmentData
  if (+score < 0) {
    window.notification('Nilai', 'tidak boleh kurang dari 0', 'warning')
    return
  } else if (+score > 100) {
    window.notification('Nilai', 'tidak boleh lebih dari 100', 'warning')
    return
  }

  const swalConfig = {
    title: '<h4>Apa anda akan mengubah nilai?</h4>',
    html: `
      <p class = "f-16 f-w-500">Nilai: <span class = "text-dark f-w-700">${score}</span><p>
      ${note
        ? `<p class="f-16 f-w-500">Catatan: <span class="text-dark f-w-300">${note}</span><p>`
        : ''
      }
    `,
    icon: 'question',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ya, ubah!',
    cancelButtonText: 'Periksa kembali',
    customClass: {
      content: 'd-flex'
    },
  }

  Swal.fire(swalConfig).then(async (result) => {
    if (result.isConfirmed) {
      let form = new FormData()
      form.append('user_id', assignmentUser.user_id)
      form.append('content_id', assignmentUser.content_id)
      form.append('score', Math.abs(score))
      form.append('note', note)
      setLoading(true)
      const response = await putRequest('content-score-detail-siswa', form)
      setLoading(false)
      if (response) {
        window.$('#tugasKomentar').modal('hide')
        setIsEdit(false)
        handleCloseModal()
        await getAllUsers()
        window.notification('Nilai', 'berhasil diubah!', 'success')
      }
    }
  })
}

export default submitHandler
